export default __webpack_public_path__ + "static/media/walker-heads.96218f67.svg";